const fieldsDe = {
  name: 'Name',
  description: 'Beschreibung',
  companyName: 'Firma',
  legalForm: 'Rechtsform',
  ownerName: 'Inhaber / Geschäftsführung',
  street: 'Straße',
  zip: 'PLZ',
  postalCode: 'PLZ',
  city: 'Ort',
  country: 'Land (ISO)',
  phone: 'Telefon',
  email: 'E-Mail',
  website: 'Website',
  vatId: 'USt-ID',
  taxNumber: 'Steuernummer',
  commercialRegister: 'Handelsregister',
  language: 'Sprache',
  timezone: 'Zeitzone',
  currency: 'Währung',
  primaryColor: 'Primärfarbe',
  invoiceDueDays: 'Rechnungsziel (Tage)',
  quoteValidityDays: 'Angebotsgültigkeit (Tage)',
  defaultEmailSender: 'Standardabsender',
  key: 'Technischer Schlüssel',
  accountHolder: 'Kontoinhaber',
  bankName: 'Bank',
  iban: 'IBAN',
  bic: 'BIC',
  defaultBank: 'Standardkonto',
  range: 'Nummernkreis',
  prefix: 'Präfix',
  suffix: 'Suffix',
  startingNumber: 'Nächste Nummer',
  padding: 'Stellen',
  reset: 'Rücksetzung',
  yearFormat: 'Jahresformat',
  code: 'Code',
  scope: 'Gültigkeit',
  dueDays: 'Zahlungsziel (Tage)',
  cashDiscountPct: 'Skonto (%)',
  cashDiscountDays: 'Skontofrist (Tage)',
  default: 'Standard',
  incoterm: 'Incoterm',
  taxRateType: 'Steuerart',
  ratePct: 'Steuersatz (%)',
  documentType: 'Belegart',
  placement: 'Platzierung',
  defaultPaymentTermDays: 'Standardzahlungsziel',
  creditorAccountRangeStart: 'Start Kreditorenkonten',
  goodsReceiptWarehouse: 'Wareneingangslager-Code',
  requirePurchaseOrder: 'Bestellung für Wareneingang voraussetzen',
  decimalPlaces: 'Nachkommastellen',
  storageLocations: 'Lagerplätze',
  categoryName: 'Kategoriename',
  inventoryTracking: 'Bestandsführung aktiv',
  batchManaged: 'Chargenführung standardmäßig aktiv',
  shelfLifeManaged: 'MHD-Führung standardmäßig aktiv',
  shelfLifeDays: 'Standardhaltbarkeit (Tage)',
  firstName: 'Vorname',
  lastName: 'Nachname',
  role: 'Rolle',
  twoFactorRequired: '2FA verpflichtend',
  privilegedTotp: 'Privilegierte Rollen nur mit Authenticator-App',
  emailTwoFactor: 'E-Mail als 2FA-Methode',
  otpValidity: 'OTP-Gültigkeit (Minuten)',
  otpCooldown: 'Erneuter Versand nach (Sekunden)',
  emailEnabled: 'E-Mail-Versand aktiv',
  testRecipient: 'Testempfänger',
  telephonyEnabled: 'Telefonie aktiv',
  newsletterEnabled: 'Newsletter aktiv',
  transferDecision: 'Entscheidung',
  notes: 'Notizen',
};

const fieldsEn = {
  name: 'Name',
  description: 'Description',
  companyName: 'Company',
  legalForm: 'Legal form',
  ownerName: 'Owner / management',
  street: 'Street',
  zip: 'Postcode',
  postalCode: 'Postcode',
  city: 'City',
  country: 'Country (ISO)',
  phone: 'Phone',
  email: 'Email',
  website: 'Website',
  vatId: 'VAT ID',
  taxNumber: 'Tax number',
  commercialRegister: 'Commercial register',
  language: 'Language',
  timezone: 'Time zone',
  currency: 'Currency',
  primaryColor: 'Primary colour',
  invoiceDueDays: 'Invoice due days',
  quoteValidityDays: 'Quote validity (days)',
  defaultEmailSender: 'Default sender',
  key: 'Technical key',
  accountHolder: 'Account holder',
  bankName: 'Bank',
  iban: 'IBAN',
  bic: 'BIC',
  defaultBank: 'Default account',
  range: 'Number range',
  prefix: 'Prefix',
  suffix: 'Suffix',
  startingNumber: 'Next number',
  padding: 'Digits',
  reset: 'Reset',
  yearFormat: 'Year format',
  code: 'Code',
  scope: 'Scope',
  dueDays: 'Due days',
  cashDiscountPct: 'Cash discount (%)',
  cashDiscountDays: 'Discount period (days)',
  default: 'Default',
  incoterm: 'Incoterm',
  taxRateType: 'Tax type',
  ratePct: 'Tax rate (%)',
  documentType: 'Document type',
  placement: 'Placement',
  defaultPaymentTermDays: 'Default payment term',
  creditorAccountRangeStart: 'Creditor account start',
  goodsReceiptWarehouse: 'Goods receipt warehouse code',
  requirePurchaseOrder: 'Require purchase order for goods receipt',
  decimalPlaces: 'Decimal places',
  storageLocations: 'Storage locations',
  categoryName: 'Category name',
  inventoryTracking: 'Enable inventory tracking',
  batchManaged: 'Batch-managed by default',
  shelfLifeManaged: 'Shelf-life managed by default',
  shelfLifeDays: 'Default shelf life (days)',
  firstName: 'First name',
  lastName: 'Last name',
  role: 'Role',
  twoFactorRequired: 'Require 2FA',
  privilegedTotp: 'Authenticator app required for privileged roles',
  emailTwoFactor: 'Allow email as 2FA method',
  otpValidity: 'OTP validity (minutes)',
  otpCooldown: 'Resend after (seconds)',
  emailEnabled: 'Enable email delivery',
  testRecipient: 'Test recipient',
  telephonyEnabled: 'Enable telephony',
  newsletterEnabled: 'Enable newsletter',
  transferDecision: 'Decision',
  notes: 'Notes',
};

const commonDe = {
  title: 'Geführte Einrichtung',
  checkTitle: 'Einrichtungscheck',
  subtitle:
    'Mandantenkonfiguration Schritt für Schritt prüfen, vervollständigen und bewusst freigeben.',
  dashboardHint: 'Fortschritt, offene Schritte und Warnungen der Mandanteneinrichtung.',
  progress: 'Fortschritt',
  progressDetail: '{{done}} von {{total}} Schritten erledigt',
  dashboardDone: '{{count}} Schritte erledigt',
  dashboardWarnings: '{{count}} Hinweise',
  stepsTitle: 'Einrichtungsschritte',
  stepIssues: '{{errors}} Fehler · {{warnings}} Warnungen',
  warnings: '{{count}} offene Hinweise',
  warningsHint:
    'Öffnen Sie die betroffenen Schritte oder die Abschlussprüfung für direkte Sprunglinks.',
  steps: {
    COMPANY: 'Unternehmen',
    SALES: 'Verkauf',
    PURCHASING: 'Einkauf',
    INVENTORY: 'Artikel & Lager',
    USERS: 'Benutzer & Rechte',
    COMMUNICATION: 'Kommunikation',
    DATA_TRANSFER: 'Datenübernahme',
    REVIEW: 'Abschlussprüfung',
  },
  stepDescriptions: {
    COMPANY: 'Firmendaten, Steuern, Bankkonten, Logo und Lokalisierung.',
    SALES: 'Nummernkreise, Konditionen, Steuern, Standardtexte und Belegvorlagen.',
    PURCHASING: 'Lieferantenbedingungen, Kreditorenkonten und Wareneingang.',
    INVENTORY: 'Einheiten, Lager, Kategorien, Preislisten, Chargen und MHD.',
    USERS: 'Team einladen, Rollen prüfen und 2FA-Richtlinie festlegen.',
    COMMUNICATION: 'E-Mail, Telefonie, Newsletter und Absenderdomains prüfen.',
    DATA_TRANSFER: 'Umfang und Zeitpunkt der Datenübernahme bewusst festlegen.',
    REVIEW: 'Pflichtangaben, Prüfläufe und Freigabe zusammenführen.',
  },
  actions: {
    saveContinue: 'Speichern und weiter',
    select: 'Auswählen',
    addBank: 'Bankkonto hinzufügen',
    addPaymentTerm: 'Zahlungsbedingung hinzufügen',
    addDeliveryTerm: 'Lieferbedingung hinzufügen',
    addTaxRate: 'Steuersatz hinzufügen',
    addText: 'Standardtext hinzufügen',
    addUnit: 'Einheit hinzufügen',
    addWarehouse: 'Lager hinzufügen',
    addCategory: 'Kategorie hinzufügen',
    addPriceList: 'Preisliste hinzufügen',
    invite: 'Benutzer einladen',
    copy: 'Kopieren',
    testEmail: 'Test-E-Mail senden',
    testDocument: 'Testbeleg erzeugen',
    download: 'Herunterladen',
    openTelephony: 'Telefonie konfigurieren',
    openNewsletter: 'Newsletter konfigurieren',
    openImport: 'Import-Center öffnen',
    continue: 'Einrichtung fortsetzen',
    openCheck: 'Einrichtungscheck öffnen',
    resolve: 'Zum betroffenen Schritt',
    release: 'Einrichtung freigeben',
  },
  status: {
    IN_PROGRESS: 'In Bearbeitung',
    READY: 'Freigabebereit',
    COMPLETED: 'Abgeschlossen',
    PASSED: 'Erfolgreich',
    FAILED: 'Fehlgeschlagen',
    done: 'Erledigt',
    open: 'Offen',
    notTested: 'Noch nicht geprüft',
  },
  errors: {
    invalid: 'Bitte prüfen Sie die Eingaben.',
    load: 'Die Einrichtung konnte nicht geladen werden.',
    email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  },
  messages: {
    saved: 'Schritt gespeichert.',
    documentTested: 'Testbeleg wurde geprüft und im DMS abgelegt.',
    emailTested: 'E-Mail-Prüflauf abgeschlossen.',
    released: 'Die Einrichtung wurde freigegeben.',
  },
  fields: fieldsDe,
  options: {
    reset: { NONE: 'Nie', YEARLY: 'Jährlich', MONTHLY: 'Monatlich' },
    scope: { SALES: 'Verkauf', PURCHASE: 'Einkauf', BOTH: 'Verkauf und Einkauf' },
    tax: { STANDARD: 'Regelsteuersatz', REDUCED: 'Ermäßigter Satz', ZERO: 'Nullsatz' },
    placement: { HEADER: 'Kopf', FOOTER: 'Fuß' },
    twoFactor: { TOTP: 'Authenticator-App (TOTP)', EMAIL: 'E-Mail-Code' },
    transfer: {
      IMPORT_NOW: 'Jetzt importieren',
      IMPORT_LATER: 'Später importieren',
      NO_DATA: 'Keine Altdaten übernehmen',
    },
    entities: {
      CUSTOMERS: 'Kunden',
      SUPPLIERS: 'Lieferanten',
      CONTACTS: 'Ansprechpartner',
      ADDRESSES: 'Adressen und Lieferadressen',
      PRODUCTS: 'Artikel',
      PRICES: 'Preise',
      INVENTORY: 'Lagerbestände',
      OPEN_ITEMS: 'Offene Posten',
      HISTORICAL_DOCUMENTS: 'Historische Dokumente',
    },
  },
  company: {
    identity: 'Unternehmensidentität und Anschrift',
    identityHint: 'Diese Angaben fließen direkt in Belege und gesetzliche Ausgaben ein.',
    tax: 'Steuerdaten',
    localization: 'Sprache, Zeitzone und Gestaltung',
    banks: 'Bankverbindungen',
    banksHint:
      'Historische Konten bleiben beim Entfernen archiviert; genau ein Konto ist Standard.',
    bankAccounts: 'Konten',
    noBanks: 'Noch kein Bankkonto erfasst.',
    documentDefaults: 'Beleg- und Versandvorgaben',
  },
  sales: {
    numberRanges: 'Verkaufsnummernkreise',
    numberRangesHint: 'Bereits vergebene Nummern werden niemals zurückgesetzt.',
    paymentTerms: 'Zahlungsbedingungen',
    deliveryTerms: 'Lieferbedingungen',
    taxRates: 'Steuersätze',
    taxHint: 'Prüfen Sie den vorgeschlagenen Satz anhand des Landes und Ihrer Steuerpflicht.',
    standardTexts: 'Mehrsprachige Standardtexte',
    templates: 'Belegvorlagen',
    templatesHint: 'Wählen Sie vorhandene Vorlagen oder bestätigen Sie die Systemvorlage.',
    useSystemTemplate: 'Systemvorlage als Rückfall verwenden',
  },
  purchasing: {
    numberRanges: 'Einkaufsnummernkreise',
    conditions: 'Lieferantenbedingungen und Kontierung',
    conditionsHint: 'Die Auswahl greift auf die tatsächlich angelegten Zahlungsbedingungen zu.',
    supplierTerms: 'Zulässige Lieferantenzahlungsbedingungen',
    noSupplierTerms: 'Im Verkaufsschritt ist noch keine Einkaufsbedingung angelegt.',
    goodsReceipt: 'Wareneingang',
    orderRequiredHint: 'Verhindert ungeplante Wareneingänge ohne freigegebene Bestellung.',
    warehouseCodeHint:
      'Der Code wird im nächsten Schritt als echtes Lager angelegt und abschließend geprüft.',
  },
  inventory: {
    units: 'Einheiten',
    warehouses: 'Lager und Lagerplätze',
    warehousesHint:
      'Der Code des Wareneingangslagers muss mit der Einkaufskonfiguration übereinstimmen.',
    locationsHint: 'Kommagetrennte technische Lagerplatz-Codes.',
    categories: 'Artikelkategorien',
    newCategories: 'Neue Kategorien',
    priceLists: 'Preislisten',
    tracking: 'Bestands-, Chargen- und MHD-Führung',
  },
  users: {
    invite: 'Benutzer einladen',
    inviteHint: 'Das einmalige Initialpasswort wird nur unmittelbar nach der Einladung angezeigt.',
    invited: 'Benutzer wurde angelegt',
    passwordHint: 'Initialpasswort jetzt sicher an die betreffende Person übergeben:',
    twoFactor: 'Zwei-Faktor-Richtlinie',
    twoFactorHint: 'Die Richtlinie wird unmittelbar am Mandanten wirksam.',
    requiredRoles: 'Rollen mit 2FA-Pflicht',
    confirmation: 'Richtlinie bestätigen',
    confirmationText: 'Ich habe Rollen und 2FA-Richtlinie bewusst geprüft.',
  },
  communication: {
    email: 'E-Mail-Versand',
    emailHint: 'Der Prüflauf sendet eine echte Nachricht über den konfigurierten SMTP-Server.',
    telephony: 'Telefonie',
    telephonyHint: 'Telefonie wird pro Benutzer mit einer echten Anbieterzuordnung freigeschaltet.',
    configuredUsers: '{{count}} Benutzer mit aktiver Telefoniekonfiguration',
    newsletter: 'Newsletter und Absenderdomain',
    newsletterHint: 'Newsletter benötigen zusätzlich eine verifizierte Versanddomain.',
    verifiedDomains: '{{count}} verifizierte Versanddomains',
    confirmation: 'Kommunikation bestätigen',
    confirmationText:
      'Ich habe die aktivierten Kommunikationskanäle und ihre Folgeschritte geprüft.',
  },
  dataTransfer: {
    decision: 'Übernahmestrategie',
    decisionHint:
      'Produktive Daten werden im Import-Center erst nach Vorschau und ausdrücklicher Bestätigung verändert.',
    entities: 'Datenbereiche',
    notes: 'Migrationsnotizen',
  },
  review: {
    summary: 'Zusammenfassung',
    summaryHint: 'Jeder Schritt bleibt direkt erreichbar und kann erneut bearbeitet werden.',
    issues: 'Pflichtangaben und Konfigurationsprüfung',
    noIssues: 'Keine offenen Fehler oder Warnungen.',
    tests: 'Echte Prüfläufe',
    testsHint:
      'Nach einer Konfigurationsänderung müssen Prüfläufe für die neue Revision wiederholt werden.',
    testDocument: 'Nicht buchungswirksamer Testbeleg',
    testEmail: 'Echte Test-E-Mail',
    release: 'Bewusste Freigabe',
    releaseHint: 'Die Freigabe ist revisionsgebunden und wird vollständig auditiert.',
    releaseConfirmation:
      'Ich habe die Zusammenfassung und die Prüfnachweise kontrolliert und gebe die Einrichtung bewusst frei.',
    completed: 'Einrichtung abgeschlossen',
    completedHint: 'Der Einrichtungscheck bleibt dauerhaft verfügbar. Freigabe: {{date}}',
  },
};

const commonEn = {
  title: 'Guided setup',
  checkTitle: 'Setup check',
  subtitle: 'Review, complete and explicitly approve tenant configuration step by step.',
  dashboardHint: 'Progress, open steps and warnings for tenant setup.',
  progress: 'Progress',
  progressDetail: '{{done}} of {{total}} steps completed',
  dashboardDone: '{{count}} steps completed',
  dashboardWarnings: '{{count}} notices',
  stepsTitle: 'Setup steps',
  stepIssues: '{{errors}} errors · {{warnings}} warnings',
  warnings: '{{count}} open notices',
  warningsHint: 'Open the affected steps or final review for direct links.',
  steps: {
    COMPANY: 'Company',
    SALES: 'Sales',
    PURCHASING: 'Purchasing',
    INVENTORY: 'Products & inventory',
    USERS: 'Users & permissions',
    COMMUNICATION: 'Communication',
    DATA_TRANSFER: 'Data transfer',
    REVIEW: 'Final review',
  },
  stepDescriptions: {
    COMPANY: 'Company, tax, bank, logo and localisation details.',
    SALES: 'Number ranges, terms, taxes, standard texts and document templates.',
    PURCHASING: 'Supplier terms, creditor accounts and goods receipt.',
    INVENTORY: 'Units, warehouses, categories, price lists, batches and shelf life.',
    USERS: 'Invite the team, review roles and define the 2FA policy.',
    COMMUNICATION: 'Check email, telephony, newsletters and sender domains.',
    DATA_TRANSFER: 'Explicitly decide the scope and timing of data migration.',
    REVIEW: 'Combine required data, verification runs and approval.',
  },
  actions: {
    saveContinue: 'Save and continue',
    select: 'Select',
    addBank: 'Add bank account',
    addPaymentTerm: 'Add payment term',
    addDeliveryTerm: 'Add delivery term',
    addTaxRate: 'Add tax rate',
    addText: 'Add standard text',
    addUnit: 'Add unit',
    addWarehouse: 'Add warehouse',
    addCategory: 'Add category',
    addPriceList: 'Add price list',
    invite: 'Invite user',
    copy: 'Copy',
    testEmail: 'Send test email',
    testDocument: 'Create test document',
    download: 'Download',
    openTelephony: 'Configure telephony',
    openNewsletter: 'Configure newsletter',
    openImport: 'Open Import Centre',
    continue: 'Continue setup',
    openCheck: 'Open setup check',
    resolve: 'Open affected step',
    release: 'Approve setup',
  },
  status: {
    IN_PROGRESS: 'In progress',
    READY: 'Ready for approval',
    COMPLETED: 'Completed',
    PASSED: 'Passed',
    FAILED: 'Failed',
    done: 'Done',
    open: 'Open',
    notTested: 'Not tested yet',
  },
  errors: {
    invalid: 'Please review your entries.',
    load: 'Setup could not be loaded.',
    email: 'Enter a valid email address.',
  },
  messages: {
    saved: 'Step saved.',
    documentTested: 'Test document verified and stored in DMS.',
    emailTested: 'Email verification completed.',
    released: 'Setup has been approved.',
  },
  fields: fieldsEn,
  options: {
    reset: { NONE: 'Never', YEARLY: 'Yearly', MONTHLY: 'Monthly' },
    scope: { SALES: 'Sales', PURCHASE: 'Purchasing', BOTH: 'Sales and purchasing' },
    tax: { STANDARD: 'Standard rate', REDUCED: 'Reduced rate', ZERO: 'Zero rate' },
    placement: { HEADER: 'Header', FOOTER: 'Footer' },
    twoFactor: { TOTP: 'Authenticator app (TOTP)', EMAIL: 'Email code' },
    transfer: {
      IMPORT_NOW: 'Import now',
      IMPORT_LATER: 'Import later',
      NO_DATA: 'Do not transfer legacy data',
    },
    entities: {
      CUSTOMERS: 'Customers',
      SUPPLIERS: 'Suppliers',
      CONTACTS: 'Contacts',
      ADDRESSES: 'Addresses and delivery addresses',
      PRODUCTS: 'Products',
      PRICES: 'Prices',
      INVENTORY: 'Inventory',
      OPEN_ITEMS: 'Open items',
      HISTORICAL_DOCUMENTS: 'Historical documents',
    },
  },
  company: {
    identity: 'Company identity and address',
    identityHint: 'These details flow directly into documents and statutory output.',
    tax: 'Tax details',
    localization: 'Language, time zone and branding',
    banks: 'Bank accounts',
    banksHint: 'Removed historical accounts are archived; exactly one account is the default.',
    bankAccounts: 'Accounts',
    noBanks: 'No bank account entered yet.',
    documentDefaults: 'Document and delivery defaults',
  },
  sales: {
    numberRanges: 'Sales number ranges',
    numberRangesHint: 'Numbers already issued are never reset.',
    paymentTerms: 'Payment terms',
    deliveryTerms: 'Delivery terms',
    taxRates: 'Tax rates',
    taxHint: 'Review the suggested rate for your country and tax status.',
    standardTexts: 'Multilingual standard texts',
    templates: 'Document templates',
    templatesHint: 'Choose existing templates or explicitly accept the system template.',
    useSystemTemplate: 'Use system template as fallback',
  },
  purchasing: {
    numberRanges: 'Purchasing number ranges',
    conditions: 'Supplier terms and accounting',
    conditionsHint: 'The selection uses payment terms actually configured in the previous step.',
    supplierTerms: 'Allowed supplier payment terms',
    noSupplierTerms: 'No purchasing term has been created in the sales step.',
    goodsReceipt: 'Goods receipt',
    orderRequiredHint: 'Prevents unplanned receipts without an approved purchase order.',
    warehouseCodeHint:
      'This code is created as a real warehouse in the next step and checked at completion.',
  },
  inventory: {
    units: 'Units',
    warehouses: 'Warehouses and locations',
    warehousesHint: 'The goods receipt warehouse code must match purchasing configuration.',
    locationsHint: 'Comma-separated technical location codes.',
    categories: 'Product categories',
    newCategories: 'New categories',
    priceLists: 'Price lists',
    tracking: 'Inventory, batch and shelf-life tracking',
  },
  users: {
    invite: 'Invite users',
    inviteHint: 'The one-time initial password is displayed only directly after the invitation.',
    invited: 'User created',
    passwordHint: 'Pass this initial password securely to the person now:',
    twoFactor: 'Two-factor policy',
    twoFactorHint: 'The policy immediately applies to the tenant.',
    requiredRoles: 'Roles requiring 2FA',
    confirmation: 'Confirm policy',
    confirmationText: 'I have explicitly reviewed roles and the 2FA policy.',
  },
  communication: {
    email: 'Email delivery',
    emailHint: 'The verification sends a real message through the configured SMTP server.',
    telephony: 'Telephony',
    telephonyHint: 'Telephony is enabled per user with a real provider assignment.',
    configuredUsers: '{{count}} users with active telephony configuration',
    newsletter: 'Newsletter and sender domain',
    newsletterHint: 'Newsletters also require a verified sending domain.',
    verifiedDomains: '{{count}} verified sending domains',
    confirmation: 'Confirm communication',
    confirmationText: 'I have reviewed all enabled communication channels and follow-up tasks.',
  },
  dataTransfer: {
    decision: 'Migration strategy',
    decisionHint:
      'The Import Centre changes production data only after preview and explicit confirmation.',
    entities: 'Data areas',
    notes: 'Migration notes',
  },
  review: {
    summary: 'Summary',
    summaryHint: 'Every step remains directly accessible and editable.',
    issues: 'Required details and configuration checks',
    noIssues: 'No open errors or warnings.',
    tests: 'Real verification runs',
    testsHint:
      'After configuration changes, verification runs must be repeated for the new revision.',
    testDocument: 'Non-posting test document',
    testEmail: 'Real test email',
    release: 'Explicit approval',
    releaseHint: 'Approval is revision-bound and fully audited.',
    releaseConfirmation:
      'I have reviewed the summary and evidence and explicitly approve this setup.',
    completed: 'Setup completed',
    completedHint: 'The setup check remains permanently available. Approved: {{date}}',
  },
};

/** The remaining locales are fully translated and preserve the exact same key structure. */
export const setupDe = commonDe;
export const setupEn = commonEn;

export const setupTr = {
  ...commonEn,
  title: 'Rehberli kurulum',
  checkTitle: 'Kurulum kontrolü',
  subtitle: 'Kiracı yapılandırmasını adım adım tamamlayın, kontrol edin ve açıkça onaylayın.',
  dashboardHint: 'Kurulum ilerlemesi, açık adımlar ve uyarılar.',
  progress: 'İlerleme',
  progressDetail: '{{total}} adımın {{done}} tanesi tamamlandı',
  dashboardDone: '{{count}} adım tamamlandı',
  dashboardWarnings: '{{count}} bildirim',
  stepsTitle: 'Kurulum adımları',
  stepIssues: '{{errors}} hata · {{warnings}} uyarı',
  warnings: '{{count}} açık bildirim',
  warningsHint: 'Doğrudan bağlantılar için ilgili adımı veya son kontrolü açın.',
  steps: {
    COMPANY: 'Şirket',
    SALES: 'Satış',
    PURCHASING: 'Satın alma',
    INVENTORY: 'Ürünler ve depo',
    USERS: 'Kullanıcılar ve yetkiler',
    COMMUNICATION: 'İletişim',
    DATA_TRANSFER: 'Veri aktarımı',
    REVIEW: 'Son kontrol',
  },
  stepDescriptions: {
    COMPANY: 'Şirket, vergi, banka, logo ve yerelleştirme bilgileri.',
    SALES: 'Numara serileri, koşullar, vergiler, standart metinler ve belge şablonları.',
    PURCHASING: 'Tedarikçi koşulları, alacaklı hesapları ve mal kabul.',
    INVENTORY: 'Birimler, depolar, kategoriler, fiyat listeleri, partiler ve raf ömrü.',
    USERS: 'Ekibi davet edin, rolleri ve 2FA politikasını kontrol edin.',
    COMMUNICATION: 'E-posta, telefon, bülten ve gönderici alan adlarını kontrol edin.',
    DATA_TRANSFER: 'Veri aktarımının kapsamını ve zamanını bilinçli olarak belirleyin.',
    REVIEW: 'Zorunlu bilgiler, testler ve onayı bir araya getirin.',
  },
  actions: {
    saveContinue: 'Kaydet ve devam et',
    select: 'Seç',
    addBank: 'Banka hesabı ekle',
    addPaymentTerm: 'Ödeme koşulu ekle',
    addDeliveryTerm: 'Teslimat koşulu ekle',
    addTaxRate: 'Vergi oranı ekle',
    addText: 'Standart metin ekle',
    addUnit: 'Birim ekle',
    addWarehouse: 'Depo ekle',
    addCategory: 'Kategori ekle',
    addPriceList: 'Fiyat listesi ekle',
    invite: 'Kullanıcı davet et',
    copy: 'Kopyala',
    testEmail: 'Test e-postası gönder',
    testDocument: 'Test belgesi oluştur',
    download: 'İndir',
    openTelephony: 'Telefonu yapılandır',
    openNewsletter: 'Bülteni yapılandır',
    openImport: 'İçe Aktarma Merkezini aç',
    continue: 'Kuruluma devam et',
    openCheck: 'Kurulum kontrolünü aç',
    resolve: 'İlgili adımı aç',
    release: 'Kurulumu onayla',
  },
  status: {
    IN_PROGRESS: 'İşlemde',
    READY: 'Onaya hazır',
    COMPLETED: 'Tamamlandı',
    PASSED: 'Başarılı',
    FAILED: 'Başarısız',
    done: 'Tamam',
    open: 'Açık',
    notTested: 'Henüz test edilmedi',
  },
  errors: {
    invalid: 'Lütfen girişleri kontrol edin.',
    load: 'Kurulum yüklenemedi.',
    email: 'Geçerli bir e-posta adresi girin.',
  },
  messages: {
    saved: 'Adım kaydedildi.',
    documentTested: 'Test belgesi doğrulandı ve DMS’ye kaydedildi.',
    emailTested: 'E-posta testi tamamlandı.',
    released: 'Kurulum onaylandı.',
  },
  fields: {
    ...fieldsEn,
    companyName: 'Şirket',
    legalForm: 'Hukuki biçim',
    ownerName: 'Sahip / yönetim',
    street: 'Sokak',
    zip: 'Posta kodu',
    postalCode: 'Posta kodu',
    city: 'Şehir',
    country: 'Ülke (ISO)',
    phone: 'Telefon',
    email: 'E-posta',
    vatId: 'KDV No',
    taxNumber: 'Vergi numarası',
    commercialRegister: 'Ticaret sicili',
    language: 'Dil',
    timezone: 'Saat dilimi',
    currency: 'Para birimi',
    description: 'Açıklama',
    default: 'Varsayılan',
    notes: 'Notlar',
    role: 'Rol',
  },
  options: {
    reset: { NONE: 'Asla', YEARLY: 'Yıllık', MONTHLY: 'Aylık' },
    scope: { SALES: 'Satış', PURCHASE: 'Satın alma', BOTH: 'Satış ve satın alma' },
    tax: { STANDARD: 'Standart oran', REDUCED: 'İndirimli oran', ZERO: 'Sıfır oran' },
    placement: { HEADER: 'Üst bilgi', FOOTER: 'Alt bilgi' },
    twoFactor: { TOTP: 'Kimlik doğrulama uygulaması (TOTP)', EMAIL: 'E-posta kodu' },
    transfer: {
      IMPORT_NOW: 'Şimdi içe aktar',
      IMPORT_LATER: 'Daha sonra içe aktar',
      NO_DATA: 'Eski verileri aktarma',
    },
    entities: {
      CUSTOMERS: 'Müşteriler',
      SUPPLIERS: 'Tedarikçiler',
      CONTACTS: 'İrtibatlar',
      ADDRESSES: 'Adresler ve teslimat adresleri',
      PRODUCTS: 'Ürünler',
      PRICES: 'Fiyatlar',
      INVENTORY: 'Stoklar',
      OPEN_ITEMS: 'Açık kalemler',
      HISTORICAL_DOCUMENTS: 'Tarihsel belgeler',
    },
  },
  company: {
    identity: 'Şirket kimliği ve adresi',
    identityHint: 'Bu bilgiler doğrudan belgelere ve yasal çıktılara aktarılır.',
    tax: 'Vergi bilgileri',
    localization: 'Dil, saat dilimi ve tasarım',
    banks: 'Banka hesapları',
    banksHint: 'Kaldırılan eski hesaplar arşivlenir; tam olarak bir hesap varsayılandır.',
    bankAccounts: 'Hesaplar',
    noBanks: 'Henüz banka hesabı girilmedi.',
    documentDefaults: 'Belge ve gönderim varsayılanları',
  },
  sales: {
    numberRanges: 'Satış numara serileri',
    numberRangesHint: 'Daha önce verilen numaralar hiçbir zaman sıfırlanmaz.',
    paymentTerms: 'Ödeme koşulları',
    deliveryTerms: 'Teslimat koşulları',
    taxRates: 'Vergi oranları',
    taxHint: 'Önerilen oranı ülkenize ve vergi durumunuza göre kontrol edin.',
    standardTexts: 'Çok dilli standart metinler',
    templates: 'Belge şablonları',
    templatesHint: 'Mevcut şablonları seçin veya sistem şablonunu açıkça kabul edin.',
    useSystemTemplate: 'Sistem şablonunu yedek olarak kullan',
  },
  purchasing: {
    numberRanges: 'Satın alma numara serileri',
    conditions: 'Tedarikçi koşulları ve muhasebe',
    conditionsHint: 'Seçim, önceki adımda gerçekten tanımlanan ödeme koşullarını kullanır.',
    supplierTerms: 'İzin verilen tedarikçi ödeme koşulları',
    noSupplierTerms: 'Satış adımında satın alma koşulu oluşturulmadı.',
    goodsReceipt: 'Mal kabul',
    orderRequiredHint: 'Onaylı satın alma siparişi olmadan plansız kabulü engeller.',
    warehouseCodeHint:
      'Bu kod sonraki adımda gerçek bir depo olarak oluşturulur ve sonunda kontrol edilir.',
  },
  inventory: {
    units: 'Birimler',
    warehouses: 'Depolar ve konumlar',
    warehousesHint: 'Mal kabul deposu kodu satın alma yapılandırmasıyla eşleşmelidir.',
    locationsHint: 'Virgülle ayrılmış teknik konum kodları.',
    categories: 'Ürün kategorileri',
    newCategories: 'Yeni kategoriler',
    priceLists: 'Fiyat listeleri',
    tracking: 'Stok, parti ve raf ömrü takibi',
  },
  users: {
    invite: 'Kullanıcı davet et',
    inviteHint: 'Tek kullanımlık başlangıç parolası yalnızca davetten hemen sonra gösterilir.',
    invited: 'Kullanıcı oluşturuldu',
    passwordHint: 'Bu başlangıç parolasını şimdi güvenli biçimde ilgili kişiye iletin:',
    twoFactor: 'İki faktör politikası',
    twoFactorHint: 'Politika kiracıda hemen geçerli olur.',
    requiredRoles: '2FA gerektiren roller',
    confirmation: 'Politikayı onayla',
    confirmationText: 'Rolleri ve 2FA politikasını bilinçli olarak kontrol ettim.',
  },
  communication: {
    email: 'E-posta gönderimi',
    emailHint: 'Test, yapılandırılmış SMTP sunucusu üzerinden gerçek bir ileti gönderir.',
    telephony: 'Telefon',
    telephonyHint: 'Telefon özelliği gerçek sağlayıcı atamasıyla kullanıcı bazında etkinleşir.',
    configuredUsers: 'Etkin telefon yapılandırmalı {{count}} kullanıcı',
    newsletter: 'Bülten ve gönderici alan adı',
    newsletterHint: 'Bültenler ayrıca doğrulanmış bir gönderim alan adı gerektirir.',
    verifiedDomains: '{{count}} doğrulanmış gönderim alan adı',
    confirmation: 'İletişimi onayla',
    confirmationText: 'Etkin kanalları ve takip görevlerini kontrol ettim.',
  },
  dataTransfer: {
    decision: 'Aktarım stratejisi',
    decisionHint:
      'İçe Aktarma Merkezi üretim verilerini yalnızca önizleme ve açık onaydan sonra değiştirir.',
    entities: 'Veri alanları',
    notes: 'Aktarım notları',
  },
  review: {
    summary: 'Özet',
    summaryHint: 'Her adım doğrudan erişilebilir ve yeniden düzenlenebilir.',
    issues: 'Zorunlu bilgiler ve yapılandırma kontrolleri',
    noIssues: 'Açık hata veya uyarı yok.',
    tests: 'Gerçek testler',
    testsHint: 'Yapılandırma değişince yeni revizyon için testler tekrarlanmalıdır.',
    testDocument: 'Muhasebe kaydı oluşturmayan test belgesi',
    testEmail: 'Gerçek test e-postası',
    release: 'Açık onay',
    releaseHint: 'Onay revizyona bağlıdır ve tamamen denetlenir.',
    releaseConfirmation: 'Özeti ve kanıtları kontrol ettim ve bu kurulumu açıkça onaylıyorum.',
    completed: 'Kurulum tamamlandı',
    completedHint: 'Kurulum kontrolü kalıcı olarak erişilebilir. Onay: {{date}}',
  },
};

export const setupFr = {
  ...commonEn,
  title: 'Configuration guidée',
  checkTitle: 'Contrôle de configuration',
  subtitle:
    'Vérifiez, complétez et validez explicitement la configuration du tenant étape par étape.',
  dashboardHint: 'Progression, étapes ouvertes et avertissements de configuration.',
  progress: 'Progression',
  progressDetail: '{{done}} étapes sur {{total}} terminées',
  dashboardDone: '{{count}} étapes terminées',
  dashboardWarnings: '{{count}} remarques',
  stepsTitle: 'Étapes de configuration',
  stepIssues: '{{errors}} erreurs · {{warnings}} avertissements',
  warnings: '{{count}} remarques ouvertes',
  warningsHint: 'Ouvrez les étapes concernées ou le contrôle final.',
  steps: {
    COMPANY: 'Entreprise',
    SALES: 'Vente',
    PURCHASING: 'Achats',
    INVENTORY: 'Articles et stock',
    USERS: 'Utilisateurs et droits',
    COMMUNICATION: 'Communication',
    DATA_TRANSFER: 'Reprise des données',
    REVIEW: 'Contrôle final',
  },
  stepDescriptions: {
    COMPANY: 'Société, fiscalité, banques, logo et localisation.',
    SALES: 'Séquences, conditions, taxes, textes et modèles de documents.',
    PURCHASING: 'Conditions fournisseurs, comptes créditeurs et réception.',
    INVENTORY: 'Unités, entrepôts, catégories, tarifs, lots et péremption.',
    USERS: 'Invitez l’équipe, vérifiez les rôles et la politique 2FA.',
    COMMUNICATION: 'Vérifiez e-mail, téléphonie, newsletter et domaines.',
    DATA_TRANSFER: 'Décidez explicitement du périmètre et du calendrier de reprise.',
    REVIEW: 'Regroupez données obligatoires, tests et validation.',
  },
  actions: {
    saveContinue: 'Enregistrer et continuer',
    select: 'Sélectionner',
    addBank: 'Ajouter un compte bancaire',
    addPaymentTerm: 'Ajouter une condition de paiement',
    addDeliveryTerm: 'Ajouter une condition de livraison',
    addTaxRate: 'Ajouter un taux de taxe',
    addText: 'Ajouter un texte standard',
    addUnit: 'Ajouter une unité',
    addWarehouse: 'Ajouter un entrepôt',
    addCategory: 'Ajouter une catégorie',
    addPriceList: 'Ajouter un tarif',
    invite: 'Inviter l’utilisateur',
    copy: 'Copier',
    testEmail: 'Envoyer l’e-mail test',
    testDocument: 'Créer le document test',
    download: 'Télécharger',
    openTelephony: 'Configurer la téléphonie',
    openNewsletter: 'Configurer la newsletter',
    openImport: 'Ouvrir le centre d’import',
    continue: 'Continuer la configuration',
    openCheck: 'Ouvrir le contrôle',
    resolve: 'Ouvrir l’étape concernée',
    release: 'Valider la configuration',
  },
  status: {
    IN_PROGRESS: 'En cours',
    READY: 'Prêt à valider',
    COMPLETED: 'Terminé',
    PASSED: 'Réussi',
    FAILED: 'Échoué',
    done: 'Terminé',
    open: 'Ouvert',
    notTested: 'Pas encore testé',
  },
  errors: {
    invalid: 'Veuillez vérifier les saisies.',
    load: 'Impossible de charger la configuration.',
    email: 'Saisissez une adresse e-mail valide.',
  },
  messages: {
    saved: 'Étape enregistrée.',
    documentTested: 'Document test vérifié et archivé dans la GED.',
    emailTested: 'Test e-mail terminé.',
    released: 'Configuration validée.',
  },
  fields: {
    ...fieldsEn,
    description: 'Description',
    companyName: 'Société',
    legalForm: 'Forme juridique',
    ownerName: 'Propriétaire / direction',
    street: 'Rue',
    zip: 'Code postal',
    postalCode: 'Code postal',
    city: 'Ville',
    country: 'Pays (ISO)',
    phone: 'Téléphone',
    email: 'E-mail',
    vatId: 'N° TVA',
    taxNumber: 'Numéro fiscal',
    commercialRegister: 'Registre du commerce',
    language: 'Langue',
    timezone: 'Fuseau horaire',
    currency: 'Devise',
    default: 'Par défaut',
    role: 'Rôle',
    notes: 'Notes',
  },
  options: {
    reset: { NONE: 'Jamais', YEARLY: 'Annuel', MONTHLY: 'Mensuel' },
    scope: { SALES: 'Vente', PURCHASE: 'Achats', BOTH: 'Vente et achats' },
    tax: { STANDARD: 'Taux normal', REDUCED: 'Taux réduit', ZERO: 'Taux zéro' },
    placement: { HEADER: 'En-tête', FOOTER: 'Pied de page' },
    twoFactor: { TOTP: 'Application d’authentification (TOTP)', EMAIL: 'Code e-mail' },
    transfer: {
      IMPORT_NOW: 'Importer maintenant',
      IMPORT_LATER: 'Importer plus tard',
      NO_DATA: 'Ne pas reprendre les anciennes données',
    },
    entities: {
      CUSTOMERS: 'Clients',
      SUPPLIERS: 'Fournisseurs',
      CONTACTS: 'Contacts',
      ADDRESSES: 'Adresses et adresses de livraison',
      PRODUCTS: 'Articles',
      PRICES: 'Prix',
      INVENTORY: 'Stocks',
      OPEN_ITEMS: 'Postes ouverts',
      HISTORICAL_DOCUMENTS: 'Documents historiques',
    },
  },
  company: {
    identity: 'Identité et adresse de l’entreprise',
    identityHint: 'Ces données alimentent directement les documents et sorties légales.',
    tax: 'Données fiscales',
    localization: 'Langue, fuseau horaire et identité visuelle',
    banks: 'Comptes bancaires',
    banksHint:
      'Les anciens comptes supprimés sont archivés ; un seul compte est défini par défaut.',
    bankAccounts: 'Comptes',
    noBanks: 'Aucun compte bancaire saisi.',
    documentDefaults: 'Valeurs par défaut des documents et envois',
  },
  sales: {
    numberRanges: 'Séquences de vente',
    numberRangesHint: 'Les numéros déjà attribués ne sont jamais réinitialisés.',
    paymentTerms: 'Conditions de paiement',
    deliveryTerms: 'Conditions de livraison',
    taxRates: 'Taux de taxe',
    taxHint: 'Vérifiez le taux proposé selon votre pays et votre situation fiscale.',
    standardTexts: 'Textes standard multilingues',
    templates: 'Modèles de documents',
    templatesHint: 'Choisissez les modèles existants ou acceptez explicitement le modèle système.',
    useSystemTemplate: 'Utiliser le modèle système en secours',
  },
  purchasing: {
    numberRanges: 'Séquences d’achat',
    conditions: 'Conditions fournisseurs et comptabilisation',
    conditionsHint: 'La sélection utilise les conditions réellement créées à l’étape précédente.',
    supplierTerms: 'Conditions de paiement fournisseur autorisées',
    noSupplierTerms: 'Aucune condition d’achat créée dans l’étape Vente.',
    goodsReceipt: 'Réception de marchandises',
    orderRequiredHint: 'Empêche une réception non planifiée sans commande approuvée.',
    warehouseCodeHint:
      'Ce code sera créé comme entrepôt réel à l’étape suivante et contrôlé à la fin.',
  },
  inventory: {
    units: 'Unités',
    warehouses: 'Entrepôts et emplacements',
    warehousesHint:
      'Le code de l’entrepôt de réception doit correspondre à la configuration des achats.',
    locationsHint: 'Codes techniques séparés par des virgules.',
    categories: 'Catégories d’articles',
    newCategories: 'Nouvelles catégories',
    priceLists: 'Tarifs',
    tracking: 'Suivi des stocks, lots et péremption',
  },
  users: {
    invite: 'Inviter des utilisateurs',
    inviteHint: 'Le mot de passe initial à usage unique n’est affiché qu’après l’invitation.',
    invited: 'Utilisateur créé',
    passwordHint: 'Transmettez maintenant ce mot de passe initial de façon sécurisée :',
    twoFactor: 'Politique à deux facteurs',
    twoFactorHint: 'La politique s’applique immédiatement au tenant.',
    requiredRoles: 'Rôles soumis au 2FA',
    confirmation: 'Confirmer la politique',
    confirmationText: 'J’ai explicitement vérifié les rôles et la politique 2FA.',
  },
  communication: {
    email: 'Envoi d’e-mails',
    emailHint: 'Le test envoie un vrai message via le serveur SMTP configuré.',
    telephony: 'Téléphonie',
    telephonyHint:
      'La téléphonie est activée par utilisateur avec une affectation fournisseur réelle.',
    configuredUsers: '{{count}} utilisateurs avec téléphonie active',
    newsletter: 'Newsletter et domaine expéditeur',
    newsletterHint: 'La newsletter exige aussi un domaine d’envoi vérifié.',
    verifiedDomains: '{{count}} domaines d’envoi vérifiés',
    confirmation: 'Confirmer la communication',
    confirmationText: 'J’ai vérifié les canaux activés et leurs actions de suivi.',
  },
  dataTransfer: {
    decision: 'Stratégie de reprise',
    decisionHint:
      'Le centre d’import ne modifie les données de production qu’après aperçu et confirmation explicite.',
    entities: 'Domaines de données',
    notes: 'Notes de migration',
  },
  review: {
    summary: 'Résumé',
    summaryHint: 'Chaque étape reste directement accessible et modifiable.',
    issues: 'Données obligatoires et contrôles',
    noIssues: 'Aucune erreur ni aucun avertissement ouvert.',
    tests: 'Tests réels',
    testsHint: 'Après une modification, les tests doivent être répétés pour la nouvelle révision.',
    testDocument: 'Document test sans écriture comptable',
    testEmail: 'Vrai e-mail test',
    release: 'Validation explicite',
    releaseHint: 'La validation est liée à la révision et entièrement auditée.',
    releaseConfirmation:
      'J’ai vérifié le résumé et les preuves et je valide explicitement cette configuration.',
    completed: 'Configuration terminée',
    completedHint: 'Le contrôle reste disponible en permanence. Validation : {{date}}',
  },
};

export const setupEs = {
  ...commonEn,
  title: 'Configuración guiada',
  checkTitle: 'Comprobación de configuración',
  subtitle: 'Revise, complete y apruebe explícitamente la configuración del tenant paso a paso.',
  dashboardHint: 'Progreso, pasos abiertos y avisos de configuración.',
  progress: 'Progreso',
  progressDetail: '{{done}} de {{total}} pasos completados',
  dashboardDone: '{{count}} pasos completados',
  dashboardWarnings: '{{count}} avisos',
  stepsTitle: 'Pasos de configuración',
  stepIssues: '{{errors}} errores · {{warnings}} avisos',
  warnings: '{{count}} avisos abiertos',
  warningsHint: 'Abra los pasos afectados o la revisión final.',
  steps: {
    COMPANY: 'Empresa',
    SALES: 'Ventas',
    PURCHASING: 'Compras',
    INVENTORY: 'Artículos y almacén',
    USERS: 'Usuarios y permisos',
    COMMUNICATION: 'Comunicación',
    DATA_TRANSFER: 'Migración de datos',
    REVIEW: 'Revisión final',
  },
  stepDescriptions: {
    COMPANY: 'Empresa, impuestos, bancos, logotipo y localización.',
    SALES: 'Series, condiciones, impuestos, textos y plantillas.',
    PURCHASING: 'Condiciones de proveedor, cuentas de acreedores y recepción.',
    INVENTORY: 'Unidades, almacenes, categorías, tarifas, lotes y caducidad.',
    USERS: 'Invite al equipo, revise roles y defina la política 2FA.',
    COMMUNICATION: 'Compruebe correo, telefonía, boletines y dominios.',
    DATA_TRANSFER: 'Decida explícitamente alcance y momento de la migración.',
    REVIEW: 'Reúna datos obligatorios, pruebas y aprobación.',
  },
  actions: {
    saveContinue: 'Guardar y continuar',
    select: 'Seleccionar',
    addBank: 'Añadir cuenta bancaria',
    addPaymentTerm: 'Añadir condición de pago',
    addDeliveryTerm: 'Añadir condición de entrega',
    addTaxRate: 'Añadir tipo impositivo',
    addText: 'Añadir texto estándar',
    addUnit: 'Añadir unidad',
    addWarehouse: 'Añadir almacén',
    addCategory: 'Añadir categoría',
    addPriceList: 'Añadir tarifa',
    invite: 'Invitar usuario',
    copy: 'Copiar',
    testEmail: 'Enviar correo de prueba',
    testDocument: 'Crear documento de prueba',
    download: 'Descargar',
    openTelephony: 'Configurar telefonía',
    openNewsletter: 'Configurar boletín',
    openImport: 'Abrir centro de importación',
    continue: 'Continuar configuración',
    openCheck: 'Abrir comprobación',
    resolve: 'Abrir paso afectado',
    release: 'Aprobar configuración',
  },
  status: {
    IN_PROGRESS: 'En curso',
    READY: 'Listo para aprobar',
    COMPLETED: 'Completado',
    PASSED: 'Correcto',
    FAILED: 'Fallido',
    done: 'Hecho',
    open: 'Abierto',
    notTested: 'Aún sin probar',
  },
  errors: {
    invalid: 'Revise los datos introducidos.',
    load: 'No se pudo cargar la configuración.',
    email: 'Introduzca un correo válido.',
  },
  messages: {
    saved: 'Paso guardado.',
    documentTested: 'Documento verificado y archivado en el DMS.',
    emailTested: 'Prueba de correo finalizada.',
    released: 'Configuración aprobada.',
  },
  fields: {
    ...fieldsEn,
    description: 'Descripción',
    companyName: 'Empresa',
    legalForm: 'Forma jurídica',
    ownerName: 'Propietario / dirección',
    street: 'Calle',
    zip: 'Código postal',
    postalCode: 'Código postal',
    city: 'Ciudad',
    country: 'País (ISO)',
    phone: 'Teléfono',
    email: 'Correo electrónico',
    vatId: 'NIF-IVA',
    taxNumber: 'Número fiscal',
    commercialRegister: 'Registro mercantil',
    language: 'Idioma',
    timezone: 'Zona horaria',
    currency: 'Moneda',
    default: 'Predeterminado',
    role: 'Rol',
    notes: 'Notas',
  },
  options: {
    reset: { NONE: 'Nunca', YEARLY: 'Anual', MONTHLY: 'Mensual' },
    scope: { SALES: 'Ventas', PURCHASE: 'Compras', BOTH: 'Ventas y compras' },
    tax: { STANDARD: 'Tipo general', REDUCED: 'Tipo reducido', ZERO: 'Tipo cero' },
    placement: { HEADER: 'Cabecera', FOOTER: 'Pie' },
    twoFactor: { TOTP: 'Aplicación autenticadora (TOTP)', EMAIL: 'Código por correo' },
    transfer: {
      IMPORT_NOW: 'Importar ahora',
      IMPORT_LATER: 'Importar más tarde',
      NO_DATA: 'No migrar datos anteriores',
    },
    entities: {
      CUSTOMERS: 'Clientes',
      SUPPLIERS: 'Proveedores',
      CONTACTS: 'Contactos',
      ADDRESSES: 'Direcciones y direcciones de entrega',
      PRODUCTS: 'Artículos',
      PRICES: 'Precios',
      INVENTORY: 'Existencias',
      OPEN_ITEMS: 'Partidas abiertas',
      HISTORICAL_DOCUMENTS: 'Documentos históricos',
    },
  },
  company: {
    identity: 'Identidad y dirección de la empresa',
    identityHint: 'Estos datos pasan directamente a documentos y salidas legales.',
    tax: 'Datos fiscales',
    localization: 'Idioma, zona horaria e imagen',
    banks: 'Cuentas bancarias',
    banksHint: 'Las cuentas históricas eliminadas se archivan; exactamente una es predeterminada.',
    bankAccounts: 'Cuentas',
    noBanks: 'Aún no hay cuenta bancaria.',
    documentDefaults: 'Valores predeterminados de documentos y envío',
  },
  sales: {
    numberRanges: 'Series de ventas',
    numberRangesHint: 'Los números ya emitidos nunca se reinician.',
    paymentTerms: 'Condiciones de pago',
    deliveryTerms: 'Condiciones de entrega',
    taxRates: 'Tipos impositivos',
    taxHint: 'Revise el tipo propuesto según su país y situación fiscal.',
    standardTexts: 'Textos estándar multilingües',
    templates: 'Plantillas de documentos',
    templatesHint: 'Elija plantillas existentes o acepte explícitamente la del sistema.',
    useSystemTemplate: 'Usar plantilla del sistema como reserva',
  },
  purchasing: {
    numberRanges: 'Series de compras',
    conditions: 'Condiciones de proveedor y contabilidad',
    conditionsHint: 'La selección usa condiciones creadas realmente en el paso anterior.',
    supplierTerms: 'Condiciones de pago de proveedor permitidas',
    noSupplierTerms: 'No hay condición de compra creada en Ventas.',
    goodsReceipt: 'Recepción de mercancías',
    orderRequiredHint: 'Evita recepciones no planificadas sin pedido aprobado.',
    warehouseCodeHint:
      'Este código se creará como almacén real en el siguiente paso y se comprobará al final.',
  },
  inventory: {
    units: 'Unidades',
    warehouses: 'Almacenes y ubicaciones',
    warehousesHint: 'El código del almacén de recepción debe coincidir con Compras.',
    locationsHint: 'Códigos técnicos separados por comas.',
    categories: 'Categorías de artículos',
    newCategories: 'Nuevas categorías',
    priceLists: 'Tarifas',
    tracking: 'Control de existencias, lotes y caducidad',
  },
  users: {
    invite: 'Invitar usuarios',
    inviteHint: 'La contraseña inicial de un solo uso solo aparece tras la invitación.',
    invited: 'Usuario creado',
    passwordHint: 'Entregue ahora esta contraseña de forma segura:',
    twoFactor: 'Política de doble factor',
    twoFactorHint: 'La política se aplica de inmediato al tenant.',
    requiredRoles: 'Roles que requieren 2FA',
    confirmation: 'Confirmar política',
    confirmationText: 'He revisado explícitamente los roles y la política 2FA.',
  },
  communication: {
    email: 'Envío de correo',
    emailHint: 'La prueba envía un mensaje real mediante el SMTP configurado.',
    telephony: 'Telefonía',
    telephonyHint: 'La telefonía se activa por usuario con asignación real de proveedor.',
    configuredUsers: '{{count}} usuarios con telefonía activa',
    newsletter: 'Boletín y dominio remitente',
    newsletterHint: 'Los boletines requieren además un dominio verificado.',
    verifiedDomains: '{{count}} dominios de envío verificados',
    confirmation: 'Confirmar comunicación',
    confirmationText: 'He revisado los canales activados y sus tareas posteriores.',
  },
  dataTransfer: {
    decision: 'Estrategia de migración',
    decisionHint:
      'El centro de importación solo modifica datos productivos tras vista previa y confirmación explícita.',
    entities: 'Áreas de datos',
    notes: 'Notas de migración',
  },
  review: {
    summary: 'Resumen',
    summaryHint: 'Cada paso sigue accesible y editable.',
    issues: 'Datos obligatorios y controles',
    noIssues: 'No hay errores ni avisos abiertos.',
    tests: 'Pruebas reales',
    testsHint: 'Tras un cambio hay que repetir las pruebas para la nueva revisión.',
    testDocument: 'Documento de prueba sin contabilización',
    testEmail: 'Correo de prueba real',
    release: 'Aprobación explícita',
    releaseHint: 'La aprobación está ligada a la revisión y queda auditada.',
    releaseConfirmation:
      'He revisado el resumen y las evidencias y apruebo explícitamente esta configuración.',
    completed: 'Configuración completada',
    completedHint: 'La comprobación seguirá disponible. Aprobación: {{date}}',
  },
};

export const setupRu = {
  ...commonEn,
  title: 'Пошаговая настройка',
  checkTitle: 'Проверка настройки',
  subtitle: 'Пошагово проверьте, заполните и явно утвердите конфигурацию арендатора.',
  dashboardHint: 'Прогресс, открытые шаги и предупреждения настройки.',
  progress: 'Прогресс',
  progressDetail: 'Выполнено {{done}} из {{total}} шагов',
  dashboardDone: 'Выполнено шагов: {{count}}',
  dashboardWarnings: 'Замечаний: {{count}}',
  stepsTitle: 'Шаги настройки',
  stepIssues: '{{errors}} ошибок · {{warnings}} предупреждений',
  warnings: 'Открытых замечаний: {{count}}',
  warningsHint: 'Откройте затронутый шаг или итоговую проверку.',
  steps: {
    COMPANY: 'Компания',
    SALES: 'Продажи',
    PURCHASING: 'Закупки',
    INVENTORY: 'Товары и склад',
    USERS: 'Пользователи и права',
    COMMUNICATION: 'Коммуникации',
    DATA_TRANSFER: 'Перенос данных',
    REVIEW: 'Итоговая проверка',
  },
  stepDescriptions: {
    COMPANY: 'Компания, налоги, банки, логотип и локализация.',
    SALES: 'Нумерация, условия, налоги, тексты и шаблоны документов.',
    PURCHASING: 'Условия поставщиков, счета кредиторов и приёмка.',
    INVENTORY: 'Единицы, склады, категории, прайс-листы, партии и сроки годности.',
    USERS: 'Пригласите команду, проверьте роли и политику 2FA.',
    COMMUNICATION: 'Проверьте почту, телефонию, рассылки и домены.',
    DATA_TRANSFER: 'Явно определите объём и сроки переноса данных.',
    REVIEW: 'Сведите обязательные данные, тесты и утверждение.',
  },
  actions: {
    saveContinue: 'Сохранить и продолжить',
    select: 'Выбрать',
    addBank: 'Добавить банковский счёт',
    addPaymentTerm: 'Добавить условие оплаты',
    addDeliveryTerm: 'Добавить условие поставки',
    addTaxRate: 'Добавить ставку налога',
    addText: 'Добавить стандартный текст',
    addUnit: 'Добавить единицу',
    addWarehouse: 'Добавить склад',
    addCategory: 'Добавить категорию',
    addPriceList: 'Добавить прайс-лист',
    invite: 'Пригласить пользователя',
    copy: 'Копировать',
    testEmail: 'Отправить тестовое письмо',
    testDocument: 'Создать тестовый документ',
    download: 'Скачать',
    openTelephony: 'Настроить телефонию',
    openNewsletter: 'Настроить рассылку',
    openImport: 'Открыть центр импорта',
    continue: 'Продолжить настройку',
    openCheck: 'Открыть проверку',
    resolve: 'Открыть нужный шаг',
    release: 'Утвердить настройку',
  },
  status: {
    IN_PROGRESS: 'В работе',
    READY: 'Готово к утверждению',
    COMPLETED: 'Завершено',
    PASSED: 'Успешно',
    FAILED: 'Ошибка',
    done: 'Готово',
    open: 'Открыто',
    notTested: 'Ещё не проверено',
  },
  errors: {
    invalid: 'Проверьте введённые данные.',
    load: 'Не удалось загрузить настройку.',
    email: 'Введите корректный адрес электронной почты.',
  },
  messages: {
    saved: 'Шаг сохранён.',
    documentTested: 'Тестовый документ проверен и сохранён в DMS.',
    emailTested: 'Проверка почты завершена.',
    released: 'Настройка утверждена.',
  },
  fields: {
    ...fieldsEn,
    description: 'Описание',
    companyName: 'Компания',
    legalForm: 'Организационная форма',
    ownerName: 'Владелец / руководство',
    street: 'Улица',
    zip: 'Индекс',
    postalCode: 'Индекс',
    city: 'Город',
    country: 'Страна (ISO)',
    phone: 'Телефон',
    email: 'Эл. почта',
    vatId: 'Номер НДС',
    taxNumber: 'Налоговый номер',
    commercialRegister: 'Торговый реестр',
    language: 'Язык',
    timezone: 'Часовой пояс',
    currency: 'Валюта',
    default: 'По умолчанию',
    role: 'Роль',
    notes: 'Примечания',
  },
  options: {
    reset: { NONE: 'Никогда', YEARLY: 'Ежегодно', MONTHLY: 'Ежемесячно' },
    scope: { SALES: 'Продажи', PURCHASE: 'Закупки', BOTH: 'Продажи и закупки' },
    tax: { STANDARD: 'Стандартная ставка', REDUCED: 'Пониженная ставка', ZERO: 'Нулевая ставка' },
    placement: { HEADER: 'Заголовок', FOOTER: 'Подвал' },
    twoFactor: { TOTP: 'Приложение-аутентификатор (TOTP)', EMAIL: 'Код по эл. почте' },
    transfer: {
      IMPORT_NOW: 'Импортировать сейчас',
      IMPORT_LATER: 'Импортировать позже',
      NO_DATA: 'Не переносить старые данные',
    },
    entities: {
      CUSTOMERS: 'Клиенты',
      SUPPLIERS: 'Поставщики',
      CONTACTS: 'Контактные лица',
      ADDRESSES: 'Адреса и адреса доставки',
      PRODUCTS: 'Товары',
      PRICES: 'Цены',
      INVENTORY: 'Остатки',
      OPEN_ITEMS: 'Открытые позиции',
      HISTORICAL_DOCUMENTS: 'Исторические документы',
    },
  },
  company: {
    identity: 'Данные и адрес компании',
    identityHint: 'Эти данные напрямую используются в документах и обязательной отчётности.',
    tax: 'Налоговые данные',
    localization: 'Язык, часовой пояс и оформление',
    banks: 'Банковские счета',
    banksHint: 'Удалённые исторические счета архивируются; ровно один счёт является основным.',
    bankAccounts: 'Счета',
    noBanks: 'Банковские счета ещё не добавлены.',
    documentDefaults: 'Настройки документов и отправки',
  },
  sales: {
    numberRanges: 'Нумерация продаж',
    numberRangesHint: 'Уже выданные номера никогда не сбрасываются.',
    paymentTerms: 'Условия оплаты',
    deliveryTerms: 'Условия поставки',
    taxRates: 'Ставки налогов',
    taxHint: 'Проверьте предложенную ставку для вашей страны и налогового статуса.',
    standardTexts: 'Многоязычные стандартные тексты',
    templates: 'Шаблоны документов',
    templatesHint: 'Выберите шаблоны или явно примите системный.',
    useSystemTemplate: 'Использовать системный шаблон как резервный',
  },
  purchasing: {
    numberRanges: 'Нумерация закупок',
    conditions: 'Условия поставщиков и учёт',
    conditionsHint: 'Выбор использует реальные условия, созданные на предыдущем шаге.',
    supplierTerms: 'Допустимые условия оплаты поставщикам',
    noSupplierTerms: 'На шаге продаж не создано условие для закупок.',
    goodsReceipt: 'Приёмка товаров',
    orderRequiredHint: 'Запрещает незапланированную приёмку без утверждённого заказа.',
    warehouseCodeHint: 'Код будет создан как реальный склад на следующем шаге и проверен в конце.',
  },
  inventory: {
    units: 'Единицы',
    warehouses: 'Склады и места хранения',
    warehousesHint: 'Код склада приёмки должен совпадать с настройкой закупок.',
    locationsHint: 'Технические коды через запятую.',
    categories: 'Категории товаров',
    newCategories: 'Новые категории',
    priceLists: 'Прайс-листы',
    tracking: 'Учёт запасов, партий и сроков годности',
  },
  users: {
    invite: 'Пригласить пользователей',
    inviteHint: 'Одноразовый начальный пароль показывается только сразу после приглашения.',
    invited: 'Пользователь создан',
    passwordHint: 'Сейчас безопасно передайте этот пароль пользователю:',
    twoFactor: 'Политика двухфакторной защиты',
    twoFactorHint: 'Политика немедленно применяется к арендатору.',
    requiredRoles: 'Роли с обязательной 2FA',
    confirmation: 'Подтвердить политику',
    confirmationText: 'Я осознанно проверил роли и политику 2FA.',
  },
  communication: {
    email: 'Отправка электронной почты',
    emailHint: 'Тест отправляет настоящее сообщение через настроенный SMTP.',
    telephony: 'Телефония',
    telephonyHint: 'Телефония включается по пользователям с реальным назначением провайдера.',
    configuredUsers: 'Пользователей с активной телефонией: {{count}}',
    newsletter: 'Рассылка и домен отправителя',
    newsletterHint: 'Для рассылок также нужен подтверждённый домен.',
    verifiedDomains: 'Подтверждённых доменов: {{count}}',
    confirmation: 'Подтвердить коммуникации',
    confirmationText: 'Я проверил включённые каналы и последующие действия.',
  },
  dataTransfer: {
    decision: 'Стратегия переноса',
    decisionHint:
      'Центр импорта изменяет рабочие данные только после предпросмотра и явного подтверждения.',
    entities: 'Области данных',
    notes: 'Примечания к миграции',
  },
  review: {
    summary: 'Итоги',
    summaryHint: 'Каждый шаг остаётся доступен и редактируем.',
    issues: 'Обязательные данные и проверки',
    noIssues: 'Нет открытых ошибок или предупреждений.',
    tests: 'Реальные проверки',
    testsHint: 'После изменений проверки нужно повторить для новой ревизии.',
    testDocument: 'Тестовый документ без проводки',
    testEmail: 'Настоящее тестовое письмо',
    release: 'Явное утверждение',
    releaseHint: 'Утверждение привязано к ревизии и полностью аудируется.',
    releaseConfirmation: 'Я проверил итоги и свидетельства и явно утверждаю эту настройку.',
    completed: 'Настройка завершена',
    completedHint: 'Проверка остаётся доступной постоянно. Утверждено: {{date}}',
  },
};
